<!--Only for JPPC user-->
<template>
  <div class="auth_nj">
    <div>
      <h2>本人確認情報登録</h2>
    </div>
    <router-view
      v-if="isLoaded"
      :isRegistered="isRegistered"
      :registeredData="registeredData"
      :registeredFileList="registeredFileList"
      @refetch="refetch"
    ></router-view>
  </div>
</template>

<script>
import { authNJApi } from '@/api';
import { checkUserRegion, goToLoginPage, isLogin } from '@/utils';
import { mapActions, mapGetters } from 'vuex';
import { authNJErrorMsg } from '@/utils/errorMsg';
import { NJ_OTP_URL } from '@/utils/variables';

export default {
  name: 'AuthMain',
  data() {
    return {
      isLoaded: false,
      isRegistered: false,
      registeredData: {},
      registeredFileList: [],
    };
  },
  computed: {
    ...mapGetters('userInfo', ['hasOTP']),
  },
  async created() {
    await this.isValidUser();
    await this.getRegisteredData();

    this.isLoaded = true;
  },
  methods: {
    ...mapActions('modal', ['openModal']),
    hasError(res) {
      if (res?.code === -1 || res?.code === 10000) {
        this.openModal(authNJErrorMsg(res?.message));
        return true;
      }
      return false;
    },
    async isValidUser() {
      // check is logged in user
      if (!isLogin()) {
        goToLoginPage();
      }

      // check is jppc user
      if (checkUserRegion() !== 'jppc') {
        this.$router.push({ name: 'intro', query: { ...this.$route.query } });
      }

      // check has otp user
      if (!this.hasOTP) {
        const { data } = await authNJApi.checkOTP();
        const code = data?.code;
        const hasOTP = data.data?.registered;
        if (code === -1 || code === 10000) {
          this.openModal(authNJErrorMsg(data?.message));
          this.$router.push({ name: 'intro', query: { ...this.$route.query } });
        }
        if (!hasOTP) {
          this.openModal({
            type: 'confirm',
            message: this.$t('global.otpGuide'),
            callback: () => {
              window.open(NJ_OTP_URL, '_blank');
            },
          });
          this.$router.push({ name: 'intro', query: { ...this.$route.query } });
        }
      }
    },
    async getRegisteredData() {
      const { data: authData } = await authNJApi.getAuthData();

      if (this.hasError(authData)) {
        return;
      }

      if (authData?.data) {
        this.isRegistered = true;
        this.registeredData = authData.data;
      }

      // registeredFile data 받아오기
      const { data: fileList } = await authNJApi.getFileList();

      if (this.hasError(authData)) {
        return;
      }

      if (fileList?.data) {
        this.registeredFileList = fileList.data.uploadList || [];
      }
    },
    async refetch() {
      this.isLoaded = false;
      await this.getRegisteredData();
      this.isLoaded = true;
    },
  },
};
</script>

<style scoped>
.auth_nj {
  font-family: 'Noto Sans JP', 'Helvetica Neue', Arial, 'Hiragino Kaku Gothic ProN', 'Hiragino Sans', Meiryo, sans-serif;
}
h2 {
  color: #050c42;
  font-size: 18px;
  font-weight: 700;
  line-height: 21px;
  margin: 60px 0 10px 0;
}

@media all and (max-width: 767px) {
  h2 {
    margin-left: 30px;
  }
}

@media all and (max-width: 480px) {
  h2 {
    margin-top: 50px;
    margin-left: 15px;
  }
}

@media all and (max-width: 320px) {
  h2 {
    margin-top: 40px;
  }
}
</style>
